module.exports = __webpack_public_path__ + "img/NVDA.366dcc18.png";